import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import * as constants from "@app/shared/constants";
import { Observable,combineLatest, throwError, merge, EMPTY } from 'rxjs';
import { map, distinct, mapTo, catchError, retry } from 'rxjs/operators';


import { ValuesService } from '@app/common/values/values.service';
import { DatePipe, JsonPipe } from '@angular/common';
import { inject } from '@angular/core';
import { Injectable } from '@angular/core';
import dayjs from 'dayjs';
import 'dayjs/locale/fr';

@Component({
    selector: 'app-thumb-delivery-type',
    imports: [],
    templateUrl: './thumb-delivery-type.component.html',
    styleUrl: './thumb-delivery-type.component.scss',
		changeDetection: ChangeDetectionStrategy.Eager,
		standalone: true,
})
export class ThumbDeliveryTypeComponent implements OnInit , OnDestroy{

  @Input() formGroup! : FormGroup  ;
  public deliveryModes: any = null;
  private deliverySlots: any = null;
  public message: string ='';
  private subcsiptionFormGroupMode : any;
  private subcsiptionCombineLatest : any;
  private subcsiptionFormGroupOperator : any;
  private subcsiptionDeliveryMode : any;
  private subcsiptionDeliverySlot : any;
  // private datePipe = inject(DatePipe);
  
  constructor (private valuesService: ValuesService) { }

  
  ngOnInit(): void {
    this.subcsiptionDeliveryMode= this.valuesService.getValues$(constants.C_VALUES_DELIVERY_MODE) // Get Delivery modes
      .subscribe((data: any) => { 
        this.deliveryModes = data;  
      })

      this.subcsiptionCombineLatest = 	combineLatest ([ this.formGroup.valueChanges ,this.valuesService.getValues$(constants.C_VALUES_DELIVERY_MODE), this.valuesService.getValues$(constants.C_VALUES_DELIVERY_SLOT), this.valuesService.getValues$(constants.C_VALUES_DELIVERY_OPERATOR), ]  )
      .subscribe(val=>{
        const formGroup = val[0]
        const deliveryModes = val[1]
        const slots = val[2];
        const operators = val[3];
        if( formGroup && formGroup.lnk_delivery  && formGroup.lnk_delivery.mode  ) { 
        if(  parseInt(formGroup.lnk_delivery.mode)<4){
          this.message = deliveryModes.find((deliveryMode :any) => (deliveryMode.id==parseInt(formGroup.lnk_delivery.mode))) .name
        } else {
          const askSlot = slots.find((slot :any) => slot.id === parseInt(formGroup.lnk_delivery.askslot))
          const askOp = operators.find((op :any) => op.id === parseInt(formGroup.lnk_delivery.askop))
          var niveauPrecisionhoraire = 0;
          // if (askSlot.data.level ==1 && !askOp ) niveauPrecisionhoraire = 0;
          if (askSlot && askSlot.data && askSlot.data.level && askSlot.data.level ==1 && askOp && askOp.data && askOp.data.level && askOp.data.level ===1 ) niveauPrecisionhoraire = 1;
          if (askSlot && askSlot.data && askSlot.data.level && askOp && askOp.data && askOp.data.level && askOp.data.level ===2 ) niveauPrecisionhoraire = 2;

          this.message=''

          if(this.message===''){
          this.message = 'Livraison prévu le ' + dayjs().locale('fr').format(constants.verbeuxDate)

          } else {
            
          }
        }
      }

      })



    this.subcsiptionDeliverySlot = this.valuesService.getValues$(constants.C_VALUES_DELIVERY_SLOT) // Get Delivery slots & add default value
      .subscribe((data: any) => {   this.deliverySlots = data;  })

		//  combineLatest ([ this.valuesService.getValues$(constants.C_VALUES_DELIVERY_MODE),this.valuesService.getValues$(constants.C_VALUES_DELIVERY_SLOT) ]  ) .subscribe(val=>{console.log('val',val);})

	}

  // getModeDelivery(): number {	// ?? Could be simpler
  //   if ((this.formGroup.get("lnk_delivery")?.get("mode")?.value??0)!==0) {
  //     return this.formGroup.get("lnk_delivery")?.get("mode")?.value
  //   }
  //   return 0;
  //  }

  getAskdate():string {
    // console.log('this.formGroup.get("lnk_delivery")?.get("mode")?.value',this.formGroup.get("lnk_delivery")?.get("mode")?.value);
    if (this.formGroup.get("lnk_delivery")?.get("mode")?.value && this.formGroup.get("lnk_delivery")?.get("mode")?.value < 4){
      return this.deliveryModes.find((deliveryType : any) => { deliveryType.id == this.formGroup.get("lnk_delivery")?.get("mode")?.value.toString(); })?.name;	// TODO could crash if not found
    } else{
      return this.getAskDeliveryDateAndSlot(this.formGroup.get("lnk_delivery")); // ?? mode >= 4 ?? OR no mode OR no value (WRONG)
    }
  }

  getAskDeliveryDateAndSlot(formControl_lnkDelivery: AbstractControl <any, any> | null): string {
    let retour ='';
    
    if(formControl_lnkDelivery?.get('mode')?.value === 4 && formControl_lnkDelivery?.get('askslot')?.value >0  && formControl_lnkDelivery?.get('askdatdel')?.value){
        retour ='Livraison : ';
        retour += new DatePipe  (navigator.language || 'fr-FR').transform(formControl_lnkDelivery?.get('askdatdel')?.value,'dd/MM') +' '
        
        if (+formControl_lnkDelivery?.get('askslot')?.value <3 && +formControl_lnkDelivery?.get('askop')?.value <4) {   // morning or afternoon case
            if(+formControl_lnkDelivery?.get('askop')?.value >0){ // debut milieu fin case
                 switch (+formControl_lnkDelivery?.get('askop')?.value ) {
                    case 1 : retour +='début ' ; break;
                    case 2 : retour +='milieu '; break;
                    case 3 : retour +='fin '; break;
                }
            }
            switch (+formControl_lnkDelivery?.get('askslot')?.value ) {
                case 1 : retour +='Matinée' ; break;
                case 2 : retour +='Après Midi'; break;
            } 
            return retour;

        } else  if (+formControl_lnkDelivery?.get('askslot')?.value >2  &&  +formControl_lnkDelivery?.get('askop')?.value >3  ){  // slot is an hour we need operator
             
                switch (+formControl_lnkDelivery?.get('askop')?.value ) {
                    case 4 : retour +='Avant  ' ; break;
                    case 5 : retour +='Après '; break;
                    case 6 : retour +='Heure précise '; break;
                }
            
            // retour += this.slots.find(slot => slot.id ===formControl_lnkDelivery?.get('askslot')?.value ).name 
            retour += this.deliverySlots.find((slot : any)=> slot.id === formControl_lnkDelivery?.get('askslot')?.value  ).name 
            // return this.deliveryType.get(this.formGroup.get("lnk_delivery")?.get("mode")?.value)
            return retour;
        } 
    } 
    return 'Information Livraison incomplètes';
   }
   
  getClassModeDelivery():string {
    switch (this.formGroup.get("lnk_delivery")?.get("mode")?.value ) {
      case 1:
        return 'takeaway'
      case 2:
        return 'pickup'
      case 3:
        return 'deliveryAsap'
      case 4:
        if(this.getAskdate() ==='Information Livraison incomplètes' ){
          return 'deliveryInfoNotCompleted'
        }else {
          return 'delivery'
        }	
      default:
        return '';
    }
  }
  
  getMessage():string{
    // var errorMessage = '';
    // if ((this.formGroup.get("lnk_delivery")?.get("mode")?.value ??1 )< 4) {		// Mode 1 (take away)  Mode 2 emporté plus tard  et mode 3 livraison a soon as possible => always valid
		// 	errorMessage = '';
		// } else {
		// 	// if (!this.formGroup.get('lnk_delivery')?.get('askdatdel')?.value) this.errorMessage = 'Veuillez choisir une date, ';  // jamais utiliser car la date est toujours dispo
		// 	if ((this.formGroup.get('lnk_delivery')?.get('askslot')?.value ?? 0) < 1) this.errorMessage += 'Veuillez sélectionner Matin ou Après Midi, ';
		// 	if(this.niveauPrecisionhoraire ==1 &&( !this.formGroup.get("lnk_delivery")?.get("askop")?.value || Number( this.formGroup.get("lnk_delivery")?.get("askop")?.value ) > 3 )    ){this.errorMessage += 'Veuillez sélectionner Début Milieu Fin ou déselectionner Précision 1';}
		// 	if(this.niveauPrecisionhoraire ==2 &&( !this.formGroup.get("lnk_delivery")?.get("askop")?.value || Number( this.formGroup.get("lnk_delivery")?.get("askop")?.value ) < 4 )    ){this.errorMessage += 'Veuillez sélectionner Avant Après Horaire Fixe ou déselectionner Précision 2';}
		// 	if(this.niveauPrecisionhoraire ==2 &&( !this.formGroup.get("lnk_delivery")?.get("askop")?.value || Number( this.formGroup.get("lnk_delivery")?.get("askop")?.value ) >3   && ( !this.formGroup.get("lnk_delivery")?.get("askslot")?.value || Number( this.formGroup.get("lnk_delivery")?.get("askslot")?.value ) <2  ) )){this.errorMessage += 'Veuillez sélectionner un horaire ';}
		// }

    return 'salut ca va'
  }

  ngOnDestroy() {
    this.subcsiptionCombineLatest.unsubscribe
    this.subcsiptionDeliveryMode .unsubscribe 
    this.subcsiptionDeliverySlot .unsubscribe  }

 }
  